import { render, staticRenderFns } from "./AppointmentTypeList.vue?vue&type=template&id=15daedc1&"
import script from "./AppointmentTypeList.vue?vue&type=script&lang=ts&"
export * from "./AppointmentTypeList.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentTypeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports